import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface AppPreferences {
  homePage: string;
  idleTimer: number;
  screensaverTimer: number;
  setScreensaverTimer: (screensaverTimer: number) => void;
  setIdleTimer: (idleTimer: number) => void;
  setHomePage: (homePage: string) => void;
  fullScreen: boolean;
  setFullScreen: (fullScreen: boolean) => void;
  version: string;
  setVersion: (version: string) => void;
  baseStation?: string;
  setBaseStation: (baseStation?: string) => void;
  signOutAfterAction: boolean;
  setSignOutAfterAction: (signOutAfterAction: boolean) => void;
  floorPlanMode: number;
  setFloorPlanMode: (floorPlanMode: number) => void;
}

export const usePreferencesStore = create<AppPreferences>()(
  devtools(
    persist(
      (set) => ({
        idleTimer: 30,
        floorPlanMode: 1,
        screensaverTimer: 120,
        signOutAfterAction: false,
        setScreensaverTimer(screensaverTimer) {
          set({ screensaverTimer });
        },
        setFloorPlanMode(floorPlanMode) {
          set({ floorPlanMode });
        },
        setSignOutAfterAction(signOutAfterAction) {
          set({ signOutAfterAction });
        },
        setIdleTimer(idleTimer) {
          set({ idleTimer });
        },
        setBaseStation(baseStation) {
          set({ baseStation });
        },
        homePage: "/",
        fullScreen: false,
        version: "",
        setVersion(version) {
          set({ version });
        },
        setFullScreen(fullScreen) {
          set({ fullScreen });
        },
        setHomePage(homePage) {
          set({ homePage });
        },
      }),
      {
        name: "preferences-storage",
      },
    ),
  ),
);
